import { takeLatest, put, call, select } from 'redux-saga/effects';
import { REMOVE_WORKOUT_SAGA } from "../sagaTypes";
import { loaderAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import {
    getSubscriptionsSagaAction, getUserInfoSagaAction,
    getWorkoutsFromCertainSubscriptionSagaAction
} from "../sagaActions";
import { GetWorkoutsThunk } from "../thunks/GetWorkoutsThunk";

const request = data => {
    return fetch(`${ url }/remove_workout`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerRemoveWorkout(args) {
    const user = yield select(state => state.user);
    const pagination = yield select(state => state.pagination);
    const filterDate = yield select(state => state.filterDate);
    const filterTypesOptions = yield select(state => state.filterTypesOptions);
    const filterCoachesOptions = yield select(state => state.filterCoachesOptions);
    const filterOneTimeWorkout = yield select(state => state.filterOneTimeWorkout);
    const filterConstraintsOptions = yield select(state => state.filterConstraintsOptions);
    const filterWorkoutsCountOptions = yield select(state => state.filterWorkoutsCountOptions);
    const filterUser = yield select(state => state.filterUser);
    const current_subscription = yield select(state => state.current_subscription);
    const search = yield select(state => state.search);
    const subscriptions = yield select(state => state.subscriptions);
    const currentUser = yield select(state => state.currentUser);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('workout_id', args.data.workout_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Если удаляли тренировку из текущего абонемента (карточка клиента или страница с абонементами)
            if (args.data?.location) {
                // Обновляем список абонементов
                if (args.data.location === '/fitness/subscriptions') {
                    yield put(getSubscriptionsSagaAction({
                        page: pagination.current,
                        search,
                        date: subscriptions.current_month
                    }));
                }
                // Обновляем абонементы текущего пользователя
                else if (args.data.location === '/fitness/users') {
                    yield put(getUserInfoSagaAction({ id: currentUser.id }));
                }
            }

            // Если есть id текущего абонемента, получаем тренировки по этому абонементу
            if (current_subscription.subscription_id) {
                yield put(getWorkoutsFromCertainSubscriptionSagaAction({
                    subscription_id: current_subscription.subscription_id
                }));
            }
            // Иначе, получаем список тренировок на странице с тренировками
            else {
                yield put(GetWorkoutsThunk({
                    page: pagination.current,
                    from: filterDate.from,
                    to: filterDate.to,
                    subscription_type: JSON.stringify(filterTypesOptions.filter(el => el.active).map(el => el.id)),
                    subscription_coach: JSON.stringify(filterCoachesOptions.filter(el => el.active).map(el => el.id)),
                    subscription_constraints: JSON.stringify(filterConstraintsOptions.filter(el => el.active).map(el => el.id)),
                    subscription_workouts_count: JSON.stringify(filterWorkoutsCountOptions.filter(el => el.active).map(el => el.id)),
                    filter_user: filterUser.user.id,
                    oneTime: filterOneTimeWorkout
                }));
            }

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherRemoveWorkout() {
    yield takeLatest(REMOVE_WORKOUT_SAGA, workerRemoveWorkout);
}